module.exports = __webpack_public_path__ + "img/filter.1ab30bb6.svg";